import React from 'react'
import {renderComponent} from './Layout'

function renderColumns(column, i) {
    const classNames = ['col']
    classNames.push(column.settings.class)

    return (
        <div key={i} className={classNames.join(' ')}>
            { column.children.map(renderComponent) }
        </div>
    )
}

const Grid = ({ columns, settings }) => {
    const classNames = ["grid"]
    if (settings.class) {
        classNames.push(settings.class)
    }

    return (
        <div className={classNames.join(' ')}>
            {columns.map(renderColumns)}
        </div>  
    )
}

export default Grid


// WEBPACK FOOTER //
// ./src/components/Grid.js